<template>
  <v-dialog
    :modelValue="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    @update:modelValue="(val) => $emit('close')"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">
          {{ $t(dialogTitle) }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        {{ $t(dialogSubtitle) }}
      </v-card-text>
      <v-card-text>
        <v-select
          id="lang"
          v-model="language"
          :items="languages"
          item-title="text"
          item-value="value"
          label="Langue / Language"
          hide-details
          outlined
          dense
        />
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="agree" :loading="loading" :disabled="loading">
          {{ $t(submitBtnLabel) }}
        </v-btn>
        <v-btn color="grey" text @click="cancel" :disabled="loading">
          {{ $t('labels.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {
  ref, reactive, onMounted, defineProps, defineEmits,
} from 'vue';

// Define props
// Define props (not assigned to a variable since unused)
// Define props (not assigned to a variable since unused)
defineProps({
  dialog: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  dialogTitle: {
    type: String,
    default: 'labels.download_cert',
  },
  dialogSubtitle: {
    type: String,
    default: 'labels.select_lang',
  },
  submitBtnLabel: {
    type: String,
    default: 'labels.download',
  },
});

// Define emits
const emit = defineEmits(['confirm', 'close']);

// Reactive state
const options = reactive({
  color: 'primary',
  width: 500,
  zIndex: 200,
});

const languages = [
  { value: 'fr', text: 'Français' },
  { value: 'en', text: 'English' },
  { value: 'es', text: 'Español' },
  { value: 'pt', text: 'Português' },
];

const language = ref('en'); // default language

// Methods
const agree = () => {
  emit('confirm', language.value);
};

const cancel = () => {
  emit('close');
};

// Lifecycle hooks
onMounted(() => {
  language.value = localStorage.getItem('locale') || 'en';
});
</script>
